<template>
  <v-container>
    <v-card>
      <v-card-title>
        Bem-vindo ao Dashboard!
      </v-card-title>
      <v-card-text>
        Navegue pelo menu lateral para acessar as outras funcionalidades.
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'DashboardPage' // Usando nome com duas palavras para seguir as boas práticas
}
</script>